const giftNote = document.querySelectorAll('#gift-note');

giftNote.forEach((element, index) => {
  element.querySelector('.note-msg .note-msg__checkbox').id = `note-msg__checkbox_${index}`
  element.querySelector('.note-msg .note-msg__checkbox').nextSibling.nextSibling.htmlFor = `note-msg__checkbox_${index}`;


  const noteMessage = element.querySelector('.note-msg .text-area');
  const showNoteButton = element.querySelector('.note-msg .note-msg__checkbox');
  let idGiftProduct;
  if (showNoteButton) {
    idGiftProduct = showNoteButton.getAttribute("data-gift-id");
  }
  if (noteMessage.value == "") {
    changeQty(idGiftProduct, "0");
  } else {
    changeQty(idGiftProduct, "1");
  }

  showNoteButton.addEventListener("click", (e)=> {
    if (showNoteButton.checked) {
      noteMessage.parentNode.style.maxHeight = "166px";
    } else {
      noteMessage.parentNode.style.maxHeight = "0px";
      noteMessage.value = "";
      changeQty(idGiftProduct, "0");
      setTimeout(() => {
        updateCartNoteGift("");
      }, 500);
      setTimeout(() => {
        location.reload();
      }, 1000);
    }
  })
  noteMessage.addEventListener("change", (e) => {
    saveNote();
  });

  noteMessage.addEventListener("mouseout", (e) => {
    if (noteMessage == element.activeElement) {
      saveNote();
    }
  })

  function saveNote() {
    let text = element.querySelector('.note-msg .text-area');
    updateCartNoteGift(text.value);
    setTimeout(() => {
      changeQty(idGiftProduct, "1");
    }, 500);

    setTimeout(() => {
      location.reload();
    }, 1000);
  }

  function updateCartNoteGift(text) {
    const body = JSON.stringify({ note: text });
    fetch('/cart/update.js', { ...fetchConfig(), ...{ body } })
      .then(res => res.json())

      .then(res => {
        console.log(res);
      })








      .catch(err => { throw err })
  }


  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  function changeQty(itemId, quantity) {
    const variantToChange = {
      updates: {
        [itemId]: quantity,
      },
    };
    let body = JSON.stringify(variantToChange);
    fetch('/cart/update.js', { ...fetchConfig(), ...{ body } })
      .then(res => res.json())
      .catch(err => { throw err })
  }
});
